// Constants
import { PlannerTheme } from "@ms/uno-constants/lib/local/ThemeConstants";
// Components
import { Link } from "@fluentui/react-components";
import { SecureLink } from "@ms/planner-generic-controls/lib/local/secureLink/SecureLink";
import * as React from "react";
// Styles
import { useErrorViewStyles } from "./ErrorView.styles";
// Utilities
import { customizeStyles } from "@ms/planner-generic-controls/lib/local/utilities/StyleUtilities";
import { usePlannerTheme } from "../utilities/hooks/usePlannerTheme";
/**
 * Unified error view component
 */ export const ErrorView = ({ errorText, errorSubText, imageLight, imageDark, primaryButton, secondaryButton, errorLinkDetails, customStyles })=>{
    const defaultStyles = useErrorViewStyles();
    const styles = customizeStyles(defaultStyles, customStyles);
    const [showDetailsForError, setShowDetailsForError] = React.useState(false);
    const plannerTheme = usePlannerTheme();
    // Select image based on current theme
    const heroImage = plannerTheme === PlannerTheme.Dark ? imageDark : imageLight;
    // Link renders in one of two modes:
    // 1. External link (href): renders a SecureLink that opens in a new tab
    // 2. Inline toggle (message): renders a clickable Link that reveals the message text
    const link = errorLinkDetails ? /*#__PURE__*/ React.createElement("div", {
        className: styles.errorLinkSection
    }, errorLinkDetails.href ? /*#__PURE__*/ React.createElement(SecureLink, {
        href: errorLinkDetails.href
    }, errorLinkDetails.linkText) : showDetailsForError ? /*#__PURE__*/ React.createElement("span", null, errorLinkDetails.message) : /*#__PURE__*/ React.createElement(Link, {
        inline: true,
        onClick: ()=>setShowDetailsForError(true)
    }, errorLinkDetails.linkText)) : undefined;
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.root
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.elementContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.errorImage
    }, /*#__PURE__*/ React.createElement("img", {
        src: heroImage,
        alt: "",
        role: "presentation"
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.errorText,
        "aria-live": "assertive"
    }, errorText), /*#__PURE__*/ React.createElement("div", {
        className: styles.errorSubText,
        "aria-live": "assertive"
    }, errorSubText), link, /*#__PURE__*/ React.createElement("div", {
        className: styles.buttonContainer
    }, primaryButton && /*#__PURE__*/ React.createElement("div", {
        className: styles.primaryButton
    }, primaryButton), secondaryButton && /*#__PURE__*/ React.createElement("div", {
        className: styles.secondaryButton
    }, secondaryButton))));
};
